var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
const StyledLabel = styled.label `
    display: block;
    color: ${props => props.theme.tertiary};
    font-size: 15px;
    font-weight: ${props => (props.activeFilter ? '700' : '400')};
    margin-bottom: ${props => props.marginBottom};

    ${props => props.required &&
    css `
            &:after {
                content: '*';
                color: #bf3939;
                padding-left: 5px;
                font-size: 16px;
            }
        `}
`;
const InputLabel = (_a) => {
    var { children, marginBottom, activeFilter } = _a, restProps = __rest(_a, ["children", "marginBottom", "activeFilter"]);
    return (React.createElement(StyledLabel, Object.assign({ marginBottom: marginBottom, activeFilter: activeFilter }, restProps), children));
};
export default InputLabel;
